import { render, staticRenderFns } from "./PointNetridecashStore.vue?vue&type=template&id=583e1edc"
import script from "./PointNetridecashStore.vue?vue&type=script&lang=js"
export * from "./PointNetridecashStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports